import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useRegister } from '../api/useAuth'
import { getErrMsg } from '../api/client'
import Input from '../components/ui/Input'
import toast from 'react-hot-toast'

export default function Register() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ username: '', email: '', password: '', confirm: '' })
  const [showPwd, setShowPwd] = useState(false)
  const [errors, setErrors] = useState({})

  const { mutate: register, isPending } = useRegister()

  const validate = () => {
    const e = {}
    if (form.username.length < 3) e.username = 'Минимум 3 символа'
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = 'Введите корректный email'
    if (form.password.length < 8) e.password = 'Минимум 8 символов'
    if (form.password !== form.confirm) e.confirm = 'Пароли не совпадают'
    return e
  }

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }))

  const handleSubmit = (e) => {
    e.preventDefault()
    const errs = validate()
    if (Object.keys(errs).length) { setErrors(errs); return }
    setErrors({})
    register(
      { username: form.username, email: form.email, password: form.password },
      {
        onSuccess: () => { toast.success('Аккаунт создан!'); navigate('/') },
        onError: (err) => toast.error(getErrMsg(err, 'Ошибка регистрации')),
      }
    )
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-sm rounded-2xl p-8 flex flex-col gap-6 bg-surface border border-line">
        <div className="text-center">
          <h1 className="text-2xl font-black">Регистрация</h1>
          <p className="text-sm mt-1 text-muted">Создайте аккаунт бесплатно</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input label="Имя пользователя" type="text" placeholder="mangareader"
            value={form.username} onChange={set('username')} error={errors.username} autoComplete="username" />
          <Input label="Email" type="email" placeholder="you@example.com"
            value={form.email} onChange={set('email')} error={errors.email} autoComplete="email" />

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-muted">Пароль</label>
            <div className="relative">
              <input
                type={showPwd ? 'text' : 'password'}
                placeholder="Минимум 8 символов"
                value={form.password}
                onChange={set('password')}
                autoComplete="new-password"
                className={`w-full px-4 py-2.5 pr-10 rounded-lg text-sm outline-none transition-colors bg-surface2 text-fg
                  ${errors.password ? 'border border-red-500 focus:border-red-500' : 'border border-line focus:border-accent'}`}
              />
              <button type="button" onClick={() => setShowPwd((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted">
                {showPwd ? '🙈' : '👁️'}
              </button>
            </div>
            {errors.password && <span className="text-xs text-red-400">{errors.password}</span>}
          </div>

          <Input label="Подтверждение пароля" type="password" placeholder="Повторите пароль"
            value={form.confirm} onChange={set('confirm')} error={errors.confirm} autoComplete="new-password" />

          <button type="submit" disabled={isPending}
            className="w-full py-3 rounded-xl font-bold text-sm transition-all disabled:opacity-50 bg-accent text-on-accent hover:opacity-90">
            {isPending ? 'Создаём аккаунт...' : 'Зарегистрироваться'}
          </button>
        </form>

        <p className="text-sm text-center text-muted">
          Уже есть аккаунт?{' '}
          <Link to="/login" className="font-semibold text-accent">Войти</Link>
        </p>
      </div>
    </div>
  )
}
